import React from 'react';
import c from 'classnames';
import Immutable from 'immutable';

import { Paragraph } from '@uncinc/react-drupal-core';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import Hero from '../../../../components/Hero';

import './style.scss';

const TestimonialFull = ({ entity, className }) => {
  const classNames = c('Testimonial', 'Testimonial--Full', className);

  const title = entity.getIn(['title', 0, 'value'], '');
  const body = entity.getIn(['body', 0, 'processed'], '');
  const quote = entity.getIn(['field_quote', 0, 'value'], '');
  const paragraphs = entity.get('field_paragraphs', Immutable.List());

  return (
    <article className={classNames} itemScope itemType="https://schema.org/WebPage">
      <Hero title={title} noCenter />
      <Container>
        <div className="row">
          {body.length > 0 && (
            <div className="col-12 col-lg-7">
              <div className="Testimonial--Full__body">
                <WysiwygField
                  property="schema:text"
                  html={body}
                />
              </div>
            </div>
          )}

          {quote.length > 0 && (
            <div className="col-12 col-lg-7">
              <div className="Testimonial--Full__quote">
                <q className="asH1">{quote}</q>
              </div>
            </div>
          )}

          {paragraphs.size > 0 && (
            <div className="col-12 col-lg-7">
              <div className="Testimonial--Full__paragraphs">
                {paragraphs.map((paragraph) => {
                  const id = paragraph.get('target_id');

                  return (
                    <Paragraph
                      key={`paragraph:${id}`}
                      id={id}
                      entity={paragraph.get('entity')}
                    />
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </Container>
    </article>
  );
};

export default TestimonialFull;
